module.exports = __webpack_public_path__ + "img/loader.f881c130.svg";